import type { Tier } from '@/api/me';

/**
 * Alerts entry visibility (TMMAPP-0021): a subscriber (owner or sharer), or the envelope's owner
 * at any tier. A GUEST sharer never sees the item and no request is made for one.
 */
export function canSeeAlerts(tier: Tier, mine: boolean): boolean {
  return tier === 'SUBSCRIBER' || mine;
}

export function canWriteAlerts(tier: Tier): boolean {
  return tier === 'SUBSCRIBER';
}
